const RequestInspection = () =>
    import("@/views/requestInspection/RequestInspection");

export const RequestInspectionRoute = {
    path: "/requestInspection",
    component: RequestInspection,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",      
        breadcrumb: [
            {
                text: "",
                disabled: false,
                href: "#"
            }
        ],
        scope:["aps_broker","aps_executive"]
    }
};